export default __webpack_public_path__ + "static/media/so.7bccd78a.svg";